<template>
  <div class="bg-white rounded-tl-md rounded-tr-md">
    <div class="flex items-center tab shadow-border-b">
      <div
        class="px-6 py-3 relative cursor-pointer "
        :class="[tab.isActive ? 'text-neutral-700 font-medium active' : 'text-neutral-500']"
        v-for="tab in tabList"
        :key="tab.title"
        @click="selectTab(tab)"
      >
        {{ tab.title }}
      </div>
    </div>
    <div class="content">
      <component :is="selectedTab.content" />
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    tabList: [
      {
        title: 'Info Role',
        content: () => import(/* webpackChunkName: "InfoRole" */ '@/views/User/InfoRole'),
        isActive: false
      },
      {
        title: 'User',
        content: () => import(/* webpackChunkName: "InfoUser" */ '@/views/User/InfoUser'),
        isActive: false
      }
    ],
    selectedTab: ''
  }),
  mounted() {
    this.selectTab(this.tabList[0])
  },
  methods: {
    selectTab(tab) {
      this.tabList.forEach(item => (item.isActive = false))
      const tabIndex = this.tabList.findIndex(item => item.title === tab.title)
      this.tabList[tabIndex].isActive = true
      this.selectedTab = tab
    }
  }
}
</script>
<style lang="scss" scoped>
.tab {
  .active {
    &::after {
      content: '';
      display: block;
      height: 4px;
      width: 100%;
      background-color: #61d7cf;
      position: absolute;
      left: 0;
      bottom: 0;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }
  }
}
</style>
